// extracted by mini-css-extract-plugin
export default {"dots":"DotLoader_dots__IlvyD","dots-7ar3yq":"DotLoader_dots-7ar3yq__gpQEw"};